export default {
  message: {
    search: 'Cari',
    placeHolder: 'Silakan masukkan kata kunci untuk pencarian',
    quantity: 'Jumlah',
    color: 'Warna',
    design: 'Dasar Desain',
    specifications: 'Spesifikasi',
    China: 'Tiongkok',
    MinimumOrder: 'Pesanan Minimum',
    squareMeter: 'meter persegi',
    thickness: 'Ketebalan',
    price: 'Harga',
    material: 'Bahan',
    sendEmail: 'Kirim Email',
    phoneCall: 'Telepon',
    ProductDetails: 'Detail Produk',
    Ltd: 'PT. Xuchang Shitaocheng Stone Industry',
    name: 'Wang Ningbo',
    Tel: 'Telepon',
    SalesManager: 'Manajer Penjualan',
    ContactTheSupplier: 'Hubungi Supplier',
    languageList: {
      item0: 'Bahasa Tionghoa Sederhana',
      item1: 'Bahasa Inggris',
      item2: 'Bahasa Arab',
      item3: 'Bahasa Vietnam',
      // item4: 'Bahasa Indonesia'
    },
    desc: 'Melalui internet industri, Huayan Juzhu membangun sistem rantai pasokan batu global yang komprehensif, membangun matriks produk mereka sendiri, dan mengoptimalkan tata letak ekologis hulu dan hilir industri. Sejak didirikan pada tahun 2020, hampir 20 toko pusat mencakup Henan, Anhui, Shandong, Hunan, Hebei, Tianjin, dan Beijing. Volume penjualan tahunan batu buatan utama mencapai 3,6 juta meter kubik, menjadikannya produsen dan distributor batu buatan terbesar di Tiongkok, dengan 3 juta meter kubik granit, lebih dari 500.000 meter kubik batu kuarsa, dan lebih dari 200.000 meter kubik lempengan batu, menjadi pemimpin industri domestik. Melalui internet, terus mengoptimalkan struktur rantai pasokan untuk memberikan layanan yang lebih baik, meningkatkan model ritel yang ada, menggunakan big data dan perangkat lunak serta perangkat keras cerdas, melampaui pengalaman grosir batu tradisional.'
  }
}